(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero-2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-section-id] [data-lp-hero2-carousel]');
    sections.forEach(initCarousel);

    function initCarousel(root) {
      const track = root.querySelector('[data-lp-hero2-track]');
      if (!track) return;
      const slides = Array.from(track.children);
      if (slides.length <= 1) return;

      const dotsContainer = root.querySelector('[data-lp-hero2-dots]');
      const dotBtns = dotsContainer ? Array.from(dotsContainer.querySelectorAll('[data-lp-hero2-dot]')) : [];

      const autoplay = root.dataset.autoplay === 'true';
      const speed = parseInt(root.dataset.speed, 10) || 4000;
      let index = 0;
      let timer = null;

      function updateDots(i) {
        dotBtns.forEach((d, di) => d.classList.toggle('lp-hero2__dot--active', di === i));
      }

      function goTo(i, behavior) {
        index = (i + slides.length) % slides.length;
        const target = slides[index];
        if (!target) return;
        const offset = target.offsetLeft - (track.clientWidth - target.clientWidth) / 2;
        track.scrollTo({ left: offset, behavior: behavior || 'smooth' });
        updateDots(index);
      }

      function next() { goTo(index + 1); }

      function start() {
        if (!autoplay) return;
        stop();
        timer = setInterval(next, speed);
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      // Dot click navigation
      dotBtns.forEach((d) => {
        d.addEventListener('click', () => {
          stop();
          goTo(parseInt(d.getAttribute('data-lp-hero2-dot'), 10));
          start();
        });
      });

      // Pause while user is interacting
      root.addEventListener('pointerenter', stop);
      root.addEventListener('pointerleave', start);
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('touchend', start, { passive: true });

      // Keep index + dots synced with manual swiping/scrolling
      let scrollTimeout;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const center = track.scrollLeft + track.clientWidth / 2;
          let closest = 0;
          let closestDist = Infinity;
          slides.forEach((s, i) => {
            const sc = s.offsetLeft + s.clientWidth / 2;
            const d = Math.abs(sc - center);
            if (d < closestDist) { closestDist = d; closest = i; }
          });
          if (closest !== index) {
            index = closest;
            updateDots(index);
          }
        }, 80);
      }, { passive: true });

      // Position the first slide centered on load
      requestAnimationFrame(() => goTo(0, 'auto'));

      // Pause when tab not visible
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop(); else start();
      });

      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
